import api from '.';
import { buildParams } from '../helpers/tableUtil';

class Email {
  static async createEmail(data) {
    const email = await api.post('/email', data);
    return email.data;
  }

  static async getEmails({ limit, page, orderData }) {
    const params = buildParams({ limit, page, orderData });
    const emails = await api.get(`/email${params}`);
    return emails.data;
  }

  static async getEmailById(id: string) {
    const email = await api.get(`/email/${id}`);
    return email.data;
  }

  static async getEmailByParams({ filters, type }) {
    const email = await api.post('/email/getByParams', { filters, type });
    return email.data;
  }

  static async updateEmail(id: string, data) {
    delete data.id;
    const email = await api.put(`/email/${id}`, data);
    return email.data;
  }

  static async sendEmail(id: string) {
    const email = await api.put(`/email/send/${id}`);
    return email.data;
  }

  static async sendTestEmail({ email, content, subject }) {
    const sendTest = await api.post('/email/sendTest', { email, content, subject });
    return sendTest.data;
  }
}

export default Email;
